import { render, staticRenderFns } from "./ShareMasterGoal.vue?vue&type=template&id=5cbd77e0&"
import script from "./ShareMasterGoal.vue?vue&type=script&lang=js&"
export * from "./ShareMasterGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports